
let tmpl = require('./template.html');
const TG_BOTTOMFLOAT_KEY = 'TG_BOTTOMFLOAT_KEY';
adv.AdBase.extend('AdMobileMadGlobalBottomFloat', {
  init(options) {
    this.base(options);
    this.emit(adv.ENUM.EVENTS.inited);
  },
  setup(data) {
    this.data = data;
    this.emit(adv.ENUM.EVENTS.setuped);
  },
  play() {
    const _self = this;
    var ignoreIndex = false;
    if (location.hostname == 'm.17173.com' && location.pathname == '/') {
      ignoreIndex = true;
    }
    // 这边有个判断。。。
    if (!ignoreIndex && !adv.storage.get(TG_BOTTOMFLOAT_KEY)) {
      let advEl = $(this.options.selector);
      advEl.append(adv.razor(tmpl, this.data));

      const $container = adv.$('.tg-footer-fix');
      // 广告图标img加载完显示广告
      $container.find('img').on('load', function() {
        if ($container.length > 0) {
          _self._show($container);
        }
      });
      // 添加关闭事件
      $container.find('.tg-footer-fix-close').on('click', function() {
        _self._hide($container);
        const now = new Date();
        const todayEnd = new Date(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' 23:59:59').getTime();
        adv.storage.set(TG_BOTTOMFLOAT_KEY, 'ignoreThis', todayEnd - Date.now(), '17173.com', '/');
      })

      this.emit(adv.ENUM.EVENTS.played);
    }
  },
  _show(el) {
    el.css('display', 'block')
  },
  _hide(el) {
    el.css('display', 'none')
  }
})



// WEBPACK FOOTER //
// ./v1-0/production.js